module.exports = __webpack_public_path__ + "img/kf.90466b90.png";